import axios from 'axios';

const api = axios.create({
  baseURL: "https://backend.shieldxsports.com/api/v1/"
});

export default api;